import React, { useEffect, useRef, useContext } from 'react';
import axios from 'axios';
import AuthContext from '../../context/AuthContext'; 
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './styles/LoginRegister.module.css'; 


function GoogleSignInButton({ setErrorMessage, setShowModal, setAcceptInvite, acceptInvite }) {
    const { getLoggedIn } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const googleButtonRef = useRef(null);

    const handleGoogleSignIn = async (response) => {
        const idToken = response.credential;
        const inviteToken = location.state?.token; 

        try {
            const googleLoginData = {
                 idToken,
                 inviteToken: inviteToken || null 
            };

            const res = await axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/users/google`, googleLoginData, { withCredentials: true });

            if (res.status === 200) {
                await getLoggedIn(); 
                setShowModal(false); 
                setAcceptInvite(false); 

                 
                 if (acceptInvite && inviteToken && location.state?.classroomId) {
                    
                    navigate(`/my-classrooms/${location.state.classroomId}/d`, { replace: true, state: { showModal: false } });
                    
                 } else {
                    navigate("/home", { replace: true, state: { showModal: false } });
                 }
            } else {
                 setErrorMessage("Google Sign-In failed: Unexpected response.");
            }
        } catch (error) {
            console.error("Google Sign-In Error:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                setErrorMessage(error.response.data.errorMessage);
            } else {
                setErrorMessage("An error occurred during Google Sign-In.");
            }
        }
    };

    useEffect(() => {
        
        if (window.google && googleButtonRef.current) {
            window.google.accounts.id.initialize({
                client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                callback: handleGoogleSignIn 
            });
            window.google.accounts.id.renderButton(
                googleButtonRef.current, 
                { theme: "outline", size: "large", type: "standard", text: "signin_with", shape: "rectangular" } 
            ); 
        } else {
            console.error("Google Identity Services script not loaded yet or ref not ready.");
        }
    }, []); 

    return (
        
        <div ref={googleButtonRef} className={styles.googleButtonContainer}></div>
    );
}

export default GoogleSignInButton;